import { BULK_CLINICIAN_ASSIGNMENT_TABLE_QUERY } from '@/components/bulkQueue/tables/clinician/BulkClinicianAssignmentTable';
import { BULK_READY_FOR_PROMOTION_QUEUE_TABLE_QUERY } from '@/components/bulkQueue/tables/readyForPromotion/BulkReadyForPromotionQueueTable';
import { BULK_SERVICES_ASSIGNMENT_TABLE_QUERY } from '@/components/bulkQueue/tables/services/BulkServicesAssignmentTable';
import { BULK_TENTATIVE_DATE_ASSIGNMENT_TABLE_QUERY } from '@/components/bulkQueue/tables/tentativeDate/BulkTentativeDateAssignmentTable';
import { VisitRequestWorkflowStep } from '@/types/graphql';
import { DocumentNode } from '@apollo/client';

// TODO(jessica): Clean this up when all visit requests have an appointment.
export const UNKNOWN_CLINICIAN_APPOINTMENT_ID = 'UNKNOWN_CLINICIAN_APPOINTMENT_ID';

export const EMPTY_CLINICIAN_APPOINTMENT = {
    id: UNKNOWN_CLINICIAN_APPOINTMENT_ID,
    clinician: null,
    services: [],
};

const WORKFLOW_STEP_TO_TABLE_QUERY: Partial<Record<VisitRequestWorkflowStep, DocumentNode>> = {
    [VisitRequestWorkflowStep.NEEDS_SERVICES]: BULK_SERVICES_ASSIGNMENT_TABLE_QUERY,
    [VisitRequestWorkflowStep.NEEDS_CLINICIAN]: BULK_CLINICIAN_ASSIGNMENT_TABLE_QUERY,
    [VisitRequestWorkflowStep.NEEDS_TENTATIVE_DATE]: BULK_TENTATIVE_DATE_ASSIGNMENT_TABLE_QUERY,
    [VisitRequestWorkflowStep.READY_FOR_PROMOTION]: BULK_READY_FOR_PROMOTION_QUEUE_TABLE_QUERY,
};

export const getBulkTableQueryForWorkflowStep = (
    workflowStep: VisitRequestWorkflowStep | null | undefined,
): DocumentNode | null => {
    if (!workflowStep) return null;
    return WORKFLOW_STEP_TO_TABLE_QUERY[workflowStep] ?? null;
};
